import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Shield } from 'lucide-react';

export const CTASection = ({ openPopup }) => {
  return (
    <section className="py-20 bg-white relative overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: 'url(https://images.pexels.com/photos/7793999/pexels-photo-7793999.jpeg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-[#7C2D12]/95 to-[#F97316]/90"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full mb-8 border border-white/20">
            <Shield className="text-[#FED7AA] mr-2" size={24} />
            <span className="text-white font-semibold">Limited Time Offer - Act Now</span>
          </div>

          <h2 className="text-4xl md:text-6xl font-bold text-white mb-6">
            Don't Risk Losing Your Brand to Competitors
          </h2>
          
          <p className="text-xl md:text-2xl text-white/95 mb-6 leading-relaxed">
            Every day you wait to register your trademark is a day someone else could file first, potentially forcing you to rebrand entirely. Protect your business investment now with federal trademark registration that secures exclusive nationwide rights to your brand name, logo, and identity.
          </p>
          
          <p className="text-lg md:text-xl text-white/90 mb-8 leading-relaxed">
            With over 1000 trademarks successfully filed and a 95% approval rate, we have the expertise to navigate the USPTO process efficiently and secure your registration. Our comprehensive services handle everything from initial search through final registration and ongoing protection, giving you complete peace of mind that your brand is professionally safeguarded.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <Button 
              onClick={openPopup}
              size="lg"
              className="bg-white text-[#7C2D12] hover:bg-[#FED7AA] px-10 py-7 text-xl font-bold transition-all duration-300 shadow-2xl hover:shadow-3xl group"
            >
              Register My Trademark
              <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={24} />
            </Button>
            
            <Button 
              onClick={openPopup}
              size="lg"
              variant="outline"
              className="bg-white/10 backdrop-blur-sm border-2 border-white text-white hover:bg-white hover:text-[#7C2D12] px-10 py-7 text-xl font-bold transition-all duration-300"
            >
              Free Consultation
            </Button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
              <div className="text-3xl font-bold text-white mb-2">24-48 Hours</div>
              <div className="text-white/90 text-sm">Most applications prepared and filed within 2 business days of receiving your information</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
              <div className="text-3xl font-bold text-white mb-2">Expert Support</div>
              <div className="text-white/90 text-sm">Dedicated case manager guides you through every step with responsive communication</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
              <div className="text-3xl font-bold text-white mb-2">95% Success</div>
              <div className="text-white/90 text-sm">Industry-leading approval rate backed by experienced USPTO-registered attorneys</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
